interface TcData { gdprApplies?: boolean; }
interface GoogleConsent {
  callbackQueue: { push(callback: Record<string, () => void>): unknown };
  showRevocationMessage?: () => void;
}
declare global {
  interface Window {
    googlefc?: GoogleConsent;
    __tcfapi?: (command: string, version: number, callback: (data: TcData, success: boolean) => void) => void;
  }
}

// Let the AdSense tag initialize its certified CMP. Creating a googlefc
// placeholder first can be mistaken for an already installed manual CMP.
const controls = document.querySelectorAll<HTMLButtonElement>("[data-ad-privacy-settings]");
let connected = false;
let timer: number | undefined;
function connect(): void {
  const googlefc = window.googlefc;
  if (connected || typeof googlefc?.showRevocationMessage !== "function" || !googlefc.callbackQueue) return;
  connected = true;
  window.clearInterval(timer);
  window.removeEventListener("focus", connect);
  googlefc.callbackQueue.push({
    CONSENT_API_READY: () => {
      window.__tcfapi?.("addEventListener", 2, (data, success) => {
        for (const control of controls) control.hidden = !success || data?.gdprApplies !== true;
      });
    },
  });
}
connect();
if (!connected) {
  timer = window.setInterval(connect, 250);
  // An unavailable or blocked CMP must not keep a polling timer alive forever.
  window.setTimeout(() => window.clearInterval(timer), 60_000);
  window.addEventListener("focus", connect);
}
for (const control of controls) {
  control.addEventListener("click", () => {
    window.googlefc?.callbackQueue.push({ CONSENT_API_READY: () => window.googlefc?.showRevocationMessage?.() });
  });
}
